import { graphql } from "gatsby"
import { LanguagesDataFragment } from "../../graphql-types"

export const query = graphql`
  fragment LanguagesData on LanguagesYamlConnection {
    edges {
      node {
        career {
          key
          value
        }
        navigation {
          key
          value
        }
        parent {
          ... on File {
            name
          }
        }
      }
    }
  }
`

export default function extractMessages(
  languages: LanguagesDataFragment,
  lang: string
): Record<string, string> {
  const messages = {}
  languages.edges.forEach(languageDefinition => {
    if (languageDefinition.node.parent.name === lang) {
      for (const [key, translations] of Object.entries(
        languageDefinition.node
      )) {
        if (Array.isArray(translations)) {
          translations.forEach(message => {
            messages[key + "." + message.key] = message.value
          })
        }
      }
    }
  })

  return messages
}
